/**
 * @file 首页
 */
import { GetStaticProps, GetStaticPaths } from 'next';
import { ALL_LOCALES } from '@web3/base-utils';
import { getMessage } from '@web3/base-lang';
import { useFm } from '@web3/base-hooks';
import { SwapOrder } from '@/containers';

export default function Home() {
  const t = useFm();
  return (
    <div className="w-[1200px] mx-auto my-10 flex flex-col gap-4 min-h-[calc(100vh-424px)]">
      <h1 className="text-3xl font-bold">{t('swap')}</h1>
      <SwapOrder />
    </div>
  );
}

export const getStaticProps: GetStaticProps = async (context) => {
  const { locale } = context.params as any;

  const messages = await getMessage(
    'web3-order',
    {
      locale,
      entry: import.meta.url,
      additions: ['orderSeoTitle', 'orderSeoKeywords', 'orderSeoDesc'],
    },
    false
  );
  return {
    props: {
      locale,
      messages,
    },
  };
};

export const getStaticPaths: GetStaticPaths = async () => {
  return {
    paths: ALL_LOCALES.map((locale) => ({
      params: {
        locale: locale.value,
      },
    })),
    fallback: true,
  };
};
